@let a = admin();
<div class="person prov-row">
  <div class="person__main">
    <span class="person__name">
      {{ a.name }}
      @if (roleLine(); as role) {
        <small class="person__role">{{ role }}</small>
      }
    </span>
    <app-charter-person-document
      [personId]="a.personId"
      [masked]="a.documentMasked"
      [canReveal]="a.canRevealDocument" />
    @if (!former() && a.actLabel && changedFromBase()) {
      <small class="person__since">
        vigente desde {{ a.actLabel }}
        @if (a.actDate) {
          ({{ a.actDate | vaultDate }})
        }
      </small>
    }
    @if (lastAct(); as last) {
      <small class="person__since person__since--former">
        {{ last.exited ? 'saiu na' : 'listado até' }}
        {{ last.provenance.actLabel || 'ato anterior' }}
        @if (last.provenance.actDate) {
          ({{ last.provenance.actDate | vaultDate }})
        }
      </small>
    }
  </div>
  <div class="person__side">
    @if (term(); as t) {
      <span class="person__term">{{ former() ? 'mandato: ' + t.toLowerCase() : t }}</span>
    }
    @if (!former() && a.receitaStatus === 'missing-in-receita') {
      <span class="person__warn">
        <i class="pi pi-exclamation-triangle" aria-hidden="true"></i> não consta na Receita
      </span>
    }
    <app-charter-provenance
      [from]="a"
      [current]="!former()"
      [variant]="former() ? 'chip' : 'icon'"
      [base]="base()" />
    @if (history().length > 0) {
      <button
        type="button"
        class="link-btn"
        [attr.aria-expanded]="historyOpen()"
        (click)="historyOpen.set(!historyOpen())">
        <i
          class="pi"
          [class.pi-history]="!historyOpen()"
          [class.pi-chevron-up]="historyOpen()"
          aria-hidden="true"></i>
        {{ historyOpen() ? 'Fechar' : 'Histórico (' + history().length + ')' }}
      </button>
    }
  </div>
</div>
@if (historyOpen()) {
  <app-charter-history-list
    class="history"
    [rows]="history()"
    [currentActId]="former() ? null : a.actId"
    [label]="'Histórico de ' + a.name" />
}
